#import '../queries/AliyahDetailsWithParashah.graphql'
mutation AddAliyahToBarMitzvah($aliyah: ID!, $barMitzvah: String!) {
  addAliyahToBarMitzvah(aliyah: $aliyah, barMitzvah: $barMitzvah) {
    ok
    errors
    aliyah {
      ...aliyahDetailsWithParashah
    }
  }
}
